"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DATE_FORMAT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _rotateCcw = _interopRequireDefault(require("cccisd-icons/rotate-ccw3"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _Transcript = _interopRequireDefault(require("./Transcript"));
var _style = _interopRequireDefault(require("./style.css"));
var _certificateQuery = _interopRequireDefault(require("./certificateQuery.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var Cccisd = window.cccisd;
var Fortress = window.cccisd.fortress;
var DATE_FORMAT = exports.DATE_FORMAT = 'MMMM D, YYYY';
var DATE_FORMAT_UTC = 'YYYY-MM-DD HH:mm:ss';
var Certificate = function Certificate(_ref) {
  var actingPawnHash = _ref.actingPawnHash,
    actingPawnId = _ref.actingPawnId,
    basePath = _ref.basePath,
    deploymentId = _ref.deploymentId,
    deploymentSettings = _ref.deploymentSettings,
    forceName = _ref.forceName,
    hide = _ref.hide,
    language = _ref.language,
    latestFinalTestData = _ref.latestFinalTestData,
    mediatorProps = _ref.mediatorProps,
    parentDeploymentId = _ref.parentDeploymentId,
    relatedDeploymentId = _ref.relatedDeploymentId,
    settings = _ref.settings;
  var defaultCertificateId = '–';
  var certData = (0, _get2["default"])(settings, "staticCertificateId.".concat(Fortress.user.acting.data_type));
  if (certData) {
    defaultCertificateId = (0, _get2["default"])(Cccisd, certData.path) || '–';
  }

  // to prevent breaking changes, if settings doesn't contain `certificates`
  // key, convert from old to new
  var certificates = settings.certificates || [{
    backgroundId: settings.backgroundId,
    courseName: settings.courseName,
    freeText: settings.freeText
  }];
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    backgroundUrls = _useState2[0],
    setBackgroundUrls = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultCertificateId),
    _useState4 = _slicedToArray(_useState3, 2),
    certificateId = _useState4[0],
    setCertificateId = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formattedDate = _useState6[0],
    setFormattedDate = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    completedAt = _useState8[0],
    setCompletedAt = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState0 = _slicedToArray(_useState9, 2),
    name = _useState0[0],
    setName = _useState0[1];
  var _useState1 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState1, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var params = (0, _cccisdReactRouter.useParams)();
  var defaultName = 'Full Name Here';

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYLE-RELATED ///////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function getBackgroundUrl(_x, _x2) {
      return _getBackgroundUrl.apply(this, arguments);
    }
    function _getBackgroundUrl() {
      _getBackgroundUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(bgId, returnObj) {
        var baseUrl, response;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              baseUrl = Boilerplate.route('api.resources.file.index');
              _context.n = 1;
              return _cccisdAxios["default"].get("".concat(baseUrl, "?id=").concat(bgId));
            case 1:
              response = _context.v;
              if (response.status === 200 && response.data.status === 'success') {
                returnObj[bgId] = response.data.data[0].published_url;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getBackgroundUrl.apply(this, arguments);
    }
    function getCertificateDateAndUser() {
      return _getCertificateDateAndUser.apply(this, arguments);
    }
    function _getCertificateDateAndUser() {
      _getCertificateDateAndUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var actingUser, altName, result, ap, user;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!actingPawnId || !language || !deploymentId)) {
                _context2.n = 1;
                break;
              }
              actingUser = Fortress.user.acting.user || {};
              altName = actingUser.full_name || actingUser.username || defaultName;
              setName(altName);
              setFormattedDate((0, _momentTimezone["default"])().format(DATE_FORMAT));
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return _cccisdApollo.client.query({
                query: _certificateQuery["default"],
                fetchPolicy: 'network-only',
                variables: {
                  deploymentId: deploymentId,
                  language: language,
                  actingPawnHash: actingPawnHash,
                  actingPawnId: actingPawnId
                }
              });
            case 2:
              result = _context2.v;
              ap = result.data.flows.assignmentProgress;
              if (ap.completedDate) {
                setFormattedDate(_momentTimezone["default"].utc(ap.completedDate).format(DATE_FORMAT));
                setCompletedAt(_momentTimezone["default"].utc(ap.completedAt).format(DATE_FORMAT_UTC));
              } else if (latestFinalTestData && latestFinalTestData.date) {
                setFormattedDate(_momentTimezone["default"].utc(latestFinalTestData.date).format(DATE_FORMAT));
                setCompletedAt(_momentTimezone["default"].utc(latestFinalTestData.date).format(DATE_FORMAT_UTC));
              } else {
                setFormattedDate((0, _momentTimezone["default"])().format(DATE_FORMAT));
                setCompletedAt((0, _momentTimezone["default"])().format(DATE_FORMAT_UTC));
              }
              user = ap.pawn.user;
              setName(user.fullName || user.username || defaultName);
              if (!certData) {
                setCertificateId(ap.assignmentProgressId + 1000000);
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _getCertificateDateAndUser.apply(this, arguments);
    }
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var loadingPromises, startingBackgroundIds, localBackgroundUrls, backgroundIdsPromised;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (hide) {
                _context3.n = 2;
                break;
              }
              loadingPromises = [];
              startingBackgroundIds = certificates.filter(function (c) {
                return c.backgroundId;
              }).map(function (c) {
                return c.backgroundId;
              });
              localBackgroundUrls = {};
              if (Object.keys(backgroundUrls).length === 0 && startingBackgroundIds.length > 0) {
                backgroundIdsPromised = [];
                startingBackgroundIds.forEach(function (bgId) {
                  if (!backgroundIdsPromised.includes(bgId)) {
                    backgroundIdsPromised.push(bgId);
                    loadingPromises.push(getBackgroundUrl(bgId, localBackgroundUrls));
                  }
                });
              }
              loadingPromises.push(getCertificateDateAndUser());
              _context3.n = 1;
              return Promise.all(loadingPromises);
            case 1:
              setBackgroundUrls(localBackgroundUrls);
            case 2:
              setLoading(false);
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [hide]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL METHODS /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function resetCourseProgress() {
    return _resetCourseProgress.apply(this, arguments);
  }
  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function _resetCourseProgress() {
    _resetCourseProgress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var resp, subRelatedDeploymentId, options, deploymentIdsToReset, refreshLocation;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setLoading(true);
            _context4.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
              deploymentId: parentDeploymentId,
              pawnId: actingPawnId,
              hash: actingPawnHash
            }), {
              params: {
                relatedDeploymentId: relatedDeploymentId,
                isResetCourse: true,
                isPawnHash: true
              }
            });
          case 1:
            resp = _context4.v;
            subRelatedDeploymentId = (0, _get2["default"])(resp, 'data.data.deploymentId', '');
            if (!((0, _get2["default"])(resp, 'data.status', '') !== 'success' || !subRelatedDeploymentId)) {
              _context4.n = 2;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Error resetting progress.',
              type: 'danger',
              data: resp.data
            });
            return _context4.a(2);
          case 2:
            if (!(0, _get2["default"])(mediatorProps, 'course.isCurriculum', false)) {
              _context4.n = 3;
              break;
            }
            options = (0, _get2["default"])(mediatorProps, 'course.curriculumOptions', []) || [];
            deploymentIdsToReset = options.map(function (opt) {
              return opt.deploymentId;
            });
            _context4.n = 3;
            return Promise.all(deploymentIdsToReset.map(function (depId) {
              return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
                deploymentId: depId,
                pawnId: actingPawnId,
                hash: actingPawnHash
              }), {
                params: {
                  isResetCourse: true,
                  isPawnHash: true,
                  relatedDeploymentId: subRelatedDeploymentId
                }
              });
            }));
          case 3:
            refreshLocation = basePath;
            if (params.currentDeploymentId) {
              refreshLocation = refreshLocation.slice(0, refreshLocation.lastIndexOf(params.currentDeploymentId) - 1);
            }

            // do full page refresh so that all state gets reset with new deployment info
            window.location = refreshLocation;
          case 4:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _resetCourseProgress.apply(this, arguments);
  }
  function renderContent(_ref2) {
    var accreditations = _ref2.accreditations,
      certificate = _ref2.certificate,
      showAccreditation = _ref2.showAccreditation,
      _ref2$viewType = _ref2.viewType,
      viewType = _ref2$viewType === void 0 ? 'browser' : _ref2$viewType;
    var containerStyle = viewType === 'browser' ? _style["default"].certificateContainerBrowser : _style["default"].certificateContainerPrint;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: containerStyle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].certificate,
      style: {
        backgroundImage: "url(".concat(backgroundUrls[certificate.backgroundId], ")")
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].passDate
    }, formattedDate), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].certificateContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].name
    }, forceName || name), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].courseName
    }, certificate.courseName), certificate.freeText && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: certificate.freeText
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].certificateId
    }, /*#__PURE__*/_react["default"].createElement("b", null, certData && certData.label ? certData.label : 'Certificate ID:'), " ", certificateId)), showAccreditation && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].accreditationContainer
    }, accreditations.map(function (aText, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: _style["default"].accreditation
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: aText
      }));
    }))));
  }
  function renderCompletionText() {
    return settings.completionText ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].completionText
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.completionText
    })) : null;
  }
  function renderRenewCertificate() {
    // if this deployment is not the child of a parent, it's likely
    // that the parent deployment needs `isRepeatable` toggled ON in settings
    if (!settings.allowRenew || !parentDeploymentId || !completedAt) {
      return null;
    }

    // TO-DO: if repeatInterval of parent deployment is edited, all
    // child deployments should also get the updated repeatInterval. this line checks child
    var repeatInterval = (0, _get2["default"])(deploymentSettings, 'repeatInterval', false);
    if (repeatInterval && completedAt) {
      var repeatIntervalParts = repeatInterval.split(' ').filter(function (item) {
        return item;
      });
      if (repeatIntervalParts.length === 2) {
        var repeatIntervalNumber = repeatIntervalParts[0];
        var repeatIntervalUnits = repeatIntervalParts[1];
        var cutoff = (0, _momentTimezone["default"])().subtract(Number.parseInt(repeatIntervalNumber, 10), repeatIntervalUnits).format(DATE_FORMAT_UTC);
        if (cutoff < completedAt) {
          return null;
        }
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].allowRenewCertificate
    }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-secondary",
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_rotateCcw["default"], {
        spaceRight: true
      }), "Renew Certificate"),
      render: function render(_ref3) {
        var closeModal = _ref3.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.renewConfirmation
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: 'text-right ' + _style["default"].renewButtons
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary",
          onClick: closeModal
        }, "No"), /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: function onClick() {
            resetCourseProgress();
            closeModal();
          }
        }, "Yes")));
      },
      title: "Renew Certificate"
    }), /*#__PURE__*/_react["default"].createElement(_Transcript["default"], {
      actingPawnHash: actingPawnHash,
      actingPawnId: actingPawnId,
      mediatorProps: mediatorProps,
      parentDeploymentId: parentDeploymentId,
      relatedDeploymentId: relatedDeploymentId
    }));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (hide) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "You must first complete all requirements before accessing the ", settings.tabName, ".");
  }
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var downloadFilename = "Certificate_".concat(certificateId).replace(/[ -]/g, '_').replace(/[^A-Za-z0-9_]/g, '').replace(/_$/, '');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderCompletionText(), renderRenewCertificate(), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
    downloadFilename: downloadFilename
  }, certificates.map(function (certificate, index) {
    var accreditations = [certificate.accreditation1, certificate.accreditation2, certificate.accreditation3].filter(function (a) {
      return a;
    });
    var showAccreditation = accreditations.length > 0;
    return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.BrowserOnly, null, renderContent({
      accreditations: accreditations,
      certificate: certificate,
      showAccreditation: showAccreditation,
      viewType: 'browser'
    })), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.PrintOnly, null, renderContent({
      accreditations: accreditations,
      certificate: certificate,
      showAccreditation: showAccreditation,
      viewType: 'print'
    })));
  })));
};
Certificate.propTypes = {
  actingPawnHash: _propTypes["default"].string,
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  deploymentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  forceName: _propTypes["default"].string,
  hide: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  latestFinalTestData: _propTypes["default"].object,
  settings: _propTypes["default"].object
};
var _default = exports["default"] = Certificate;